import IdleTimeHandler from './idle-time-handler'

export default IdleTimeHandler
